import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { T } from 'shared/helper/translate';
var FormSubmit = function FormSubmit(_ref) {
  var busy = _ref.busy,
    disabled = _ref.disabled;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "btn btn-large btn-primary btn-squared",
    disabled: disabled
  }, /*#__PURE__*/React.createElement(T, {
    source: "Save Changes"
  })), "\xA0", busy ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-spinner-scale",
    spin: true
  }) : null);
};
export default FormSubmit;